export const CHECK_MARK = '✔';
export const CIRCLE = '⬤';
export const CIRCLE_HOLED = '🞇';
export const DELTA = '∆';
export const DOWN_POINTING_TRIANGLE = '▼';
export const INFINITY = '∞';
export const RED_CROSS_MARK = '❌';
export const RIGHT_ARROW = '➜';
export const STAR = '⭐';
export const THUMBS_DOWN = '👎';
export const THUMBS_UP = '👍';
export const WARNING = '⚠';
export const WRITING = '✍️';

export const generalResultIconLookup = {
  'pass': CHECK_MARK,
  'fail': RED_CROSS_MARK
};


// WEBPACK FOOTER //
// src/helpers/unicode.js